import { Col, Row } from 'antd';
import React, { FC } from 'react';
import ConfirmationModal from 'views/CreateProductFlow/RawMaterial/ConfirmationModal';
import styles from './validationModal.module.scss';
import { VALIDATION_MODAL_CONSTANTS } from 'constants/validationModal.constants';

interface CreateProductValidationModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleUpdate: () => void;
}

const { SUB_INFO_TEXT, UPDATE, BACK, CONFIRMATION_TEXT } =
  VALIDATION_MODAL_CONSTANTS;

const CreateProductValidationModal: FC<CreateProductValidationModalProps> = ({
  isOpen,
  onClose,
  handleUpdate,
}) => {
  const subInfo = (
    <Row className={styles.subInfo}>
      <Col span={24}>{SUB_INFO_TEXT}</Col>
    </Row>
  );

  return (
    <div>
      <ConfirmationModal
        showModal={isOpen}
        onCancel={onClose}
        width={450}
        subInfo={subInfo}
        confirmationClassName={styles.validationModal}
        confirmButtonText={UPDATE}
        cancelButtonText={BACK}
        onConfirm={handleUpdate}
        confirmationText={CONFIRMATION_TEXT}
      />
    </div>
  );
};

export default CreateProductValidationModal;
